// extracted by mini-css-extract-plugin
export default {"root":"CustomIcon_root__LnJRh","isCustomIconSelected":"CustomIcon_isCustomIconSelected__svE3i","iconImage":"CustomIcon_iconImage__U-MDt","iconLabel":"CustomIcon_iconLabel__MyJn5"};